export default __webpack_public_path__ + "images/JV.28072b3.png";